import { getAxiosInstance } from "../../api";

export const downloadCertificate = async (id) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/kalyan-certificates/${id}/download`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const downloadKalyanExcel = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/kalyan-certificates/kalyan-download`, {
      params,
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};
